import * as React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.sass";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";

const TemplateWrapper = ({ pageTitle, pageDescription, pageSlug, pageImage, children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{pageTitle ? `${pageTitle} : ${title}` : title}</title>
        <meta name="description" content={pageDescription ? pageDescription: description} />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <link rel="manifest" href="/site.webmanifest"></link>
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle ? pageTitle : title} />
        <meta property="og:url" content={`${withPrefix("")}${pageSlug ? pageSlug : "/"}`} />
        <meta property="og:description" content={pageDescription ? pageDescription: description} />
        <meta
          property="og:image"
          content={pageImage ? pageImage : `${withPrefix("/")}img/jvc_osa_canada_web_page_og_image.jpg`}
        />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
